export const ThanksNewIds = {
  CONTINUE_SHOPPING_BUTTON: 'Thanks__continue-shopping-btn',
};
